module.exports = __webpack_public_path__ + "7809b60c6e2f1e423454469238f2e8bc.jpg";